const rawBackendUrl = process.env.REACT_APP_BACKEND_URL;
export const AUTH_TOKEN_KEY = "auth_access_token";

const trimTrailingSlash = (url) => url.replace(/\/+$/, "");

function resolveBackendBaseUrl() {
  if (rawBackendUrl && rawBackendUrl.trim()) {
    return trimTrailingSlash(rawBackendUrl.trim());
  }

  if (process.env.NODE_ENV === "development") {
    return "http://localhost:8000";
  }

  throw new Error(
    "Missing REACT_APP_BACKEND_URL for non-development build. Configure it in .env.production or deployment environment variables.",
  );
}

export const BACKEND_BASE_URL = resolveBackendBaseUrl();
export const API_BASE_URL = `${BACKEND_BASE_URL}/api`;

export function getStoredAuthToken() {
  try {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  } catch {
    return null;
  }
}
